
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/principles/cheatsheet",
      function () {
        return require("private-next-pages/principles/cheatsheet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/principles/cheatsheet"])
      });
    }
  